import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import {
  BookingWizardDataAtom,
  CurrentRequestGroupIndexAtom,
} from "../../stores";

export const PlayersSelectorAtom = atom<BookingWizard.RoundPlayer[]>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);

  const rounds = bookingWizardData?.rounds;

  if (!rounds) {
    return [];
  }

  /**
   * @TODO: will need to eventually stitch known players in here.
   * Might want to break this into a "rounds" selector atom in that case.
   */

  const currentRequestGroupIndex = get(CurrentRequestGroupIndexAtom);
  const players = rounds
    .filter(
      (round) =>
        bookingWizardData?.type !== "RequestBooking" ||
        (round.bookingIndex ?? 0) === currentRequestGroupIndex
    )
    .map((r) => r.player);

  return players;
});
